import React from "react";

import State from "../../../../containers/State";
import { ReactComponent as StateIcon } from "../../../../img/icons/Cartago.svg";
import { CAMPAIGN_2025 } from '../../../../constants';

const stateName = "Cartago";
const stateId = "T8XVUyl3qTYsg3VUhndQ";

const Cartago = () => {
  return (
    <State stateName={stateName} stateId={stateId} Icon={StateIcon} year="2025" campaign={CAMPAIGN_2025}>
      <StateIcon />
    </State>
  );
};

export default Cartago;
